

function closeWidget () {
    const env = this.env;
    this.notifyClientPage({
        action: 'closeWidget',
        data: {},
    });
    env.appStore.goto('/loading');
}

export default closeWidget;
